import { useMemo } from 'react';
import {
  AnalyticsEvent,
  AnalyticsProvider,
  getAnalyticsService,
} from '../analytics';

export const useAnalytics = (
  providers: AnalyticsProvider[] = [
    AnalyticsProvider.Firebase,
    AnalyticsProvider.Amplitude,
  ],
) => {
  const services = useMemo(() => {
    return getAnalyticsService(providers);
  }, [providers]);

  const logEvent = (
    eventName: AnalyticsEvent,
    eventParams?: Record<string, any>,
  ) => {
    services.forEach((service) => service.logEvent(eventName, eventParams));
  };

  return { logEvent };
};
